/**
 * TODO: This function is used to get the bredcumb path link
 * @param \\ params -> ['admin','landing-pages', '1234']
 * @param \\ pathIndex -> 1
 * @return `/admin/landing-pages/`
 */
const getBredCumbPathLink = (params: string[], pathIndex: number) => {
  const href: string = '/' + (params?.slice(0, pathIndex + 1).join('/') || '');
  return href;
};

export default getBredCumbPathLink;
